// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://mqzjjyqipuaoagcqrrer.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1xempqeXFpcHVhb2FnY3FycmVyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTYxNjE5NzEsImV4cCI6MjA3MTczNzk3MX0.zqTjMHxkLmk4Lfsm_yK35Msp59ExXAiziYxRfBb4dzs";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});